import React, { createRef, useEffect } from "react";

import "./button.css";
import SpinLoader from "./spinLoader";

interface ButtonProps {
    children: any;
    loading?: boolean;
    thin?: boolean;
    className?: string;
    extraPadding?: boolean;
    disabled?: boolean;
    widthFitContent?: boolean;
    onClick?: () => void;
    updatePosition?: (x: number, y: number, width: number, height: number) => void;
}

export default function Button(props: ButtonProps) {

    const buttonRef = createRef<HTMLButtonElement>();

    useEffect(() => {
        if(buttonRef.current && props.updatePosition) {
            props.updatePosition(buttonRef.current.offsetLeft, buttonRef.current.offsetTop, buttonRef.current.offsetWidth, buttonRef.current.offsetHeight);
        }
    })

    return <button ref={buttonRef} onClick={() => {
        if(props.onClick) {
            props.onClick();
        }
    }} className={"txoria-button" + (props.widthFitContent ? " width-fixed-content" : "") + (props.loading != undefined ? " fixed-width" : "") + (props.thin ? " thin" : "") + (props.disabled ? " disabled" : "") + (props.extraPadding ? " padding" : "") + (props.className ? " " + props.className : "")}>
        {props.loading ? <SpinLoader/> : props.children}
    </button>;
}